import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import UserAssignment from './entity'
import Tree from "@/store/shared/entity/tree";

interface UserAssignmentState extends ListStateItem<UserAssignment>{
    editUserAssignment:UserAssignment,
    customerList: Array<any>;
    userList:Array<any>;
    userCustomerList:Array<any>;
}

class UserAssignmentModule extends ListModuleItem<UserAssignmentState,any,UserAssignment>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editUserAssignment:new UserAssignment(),
        customerList: new Array<any>(),
        userList: new Array<any>(),
        userCustomerList:new Array<any>(),
    }
    actions={
        async getAll(context:ActionContext<UserAssignmentState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/UserAssignment/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<UserAssignment>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<UserAssignmentState,any>,payload:any){
            await $http.post('services/app/UserAssignment/Create',payload.data);
            context.state.customerList=new Array<any>();
        },
        async update(context:ActionContext<UserAssignmentState,any>,payload:any){
            await $http.put('services/app/UserAssignment/Update',payload.data);
        },
        async delete(context:ActionContext<UserAssignmentState,any>,payload:any){
            await $http.delete('services/app/UserAssignment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<UserAssignmentState,any>,payload:any){
            let reponse=await $http.get('services/app/UserAssignment/Get?Id='+payload.id);
            context.state.editUserAssignment=reponse.data.result
            context.state.editUserAssignment.customerIdList=reponse.data.result.acceptUserCustomers;
            return reponse.data.result as UserAssignment;
        },
        async getCustomer(context:ActionContext<UserAssignmentState,any>,payload:any){
            
            let reponse = await $http.get('services/app/UserAssignment/GetCustomer?Id='+payload.id);
            context.state.customerList = reponse.data.result;
            
        },
        async getUser(context:ActionContext<UserAssignmentState,any>){
            
            let reponse = await $http.get('services/app/UserAssignment/GetUserOption');
            context.state.userList = reponse.data.result;
            
        },
        async return(context:ActionContext<UserAssignmentState,any>,payload:any){
            await $http.post('services/app/UserAssignment/Return',payload.data);
        },
    };
    overrideMutations={
        edit(state:UserAssignmentState,userAssignment:UserAssignment){
            state.editUserAssignment=userAssignment;
        }
    }
}
const userAssignmentModule=new UserAssignmentModule();
export default userAssignmentModule;